<template>
  <div>
    <Forms ref="frmSinisterScheduling"
            :title="$lang.Sinister.History.TitleForm"
            :showHelp="true"
            :showClearButton="false"
            :showSearchButton="false">
      <SinisterHeader ref="SinisterHeader"/>
      <div class="form-group row"><div class="col-md-12"><hr></div></div>

      <Tables ref="tableGrid"
        :columns="['Onde','Data','Tipo','Conta']"
        :showSearch="true"
        :showPrint="true"
        :showDownload="true"
        :showFullscreen="true"
        v-on:Load="onLoad">
        <tr v-for="obj in this.objList" v-bind:key="obj.ID">
          <TableColumn :IsText="true" v-on:Edit="onEdit(true, obj)" :status="obj.status" :value="obj.tableName" />
          <TableColumn :IsDatetime="true" v-on:Edit="onEdit(true, obj)" :status="obj.status" :value="obj.actionDate" />
          <TableColumn :IsText="true"     v-on:Edit="onEdit(true, obj)" :status="obj.status" :value="obj.actionDescription"/>
          <TableColumn :IsText="true"     v-on:Edit="onEdit(true, obj)" :status="obj.status" :value="obj.accountUserNameUpdate"/>
        </tr>
      </Tables>
    </Forms>
    <b-modal v-model="showModal" size="lg" title="CADASTRO DE OFICINAS" :header-bg-variant="'info'">
        <div>
          <SinisterHistoryDetails ref="sinisterhistoryDetails"
            :previousObject="this.previousObject"
            :newObject="this.newObject">
          </SinisterHistoryDetails>
        </div>
        <div slot="modal-footer" class="w-100">
          <button type="button" title="" size="sm" class="float-right btn btn-default btn-sm text-secundary" @click="showModal=false">
            <i class="fa fa-times-circle"></i> Fechar
          </button>
       </div>
    </b-modal>
  </div>
</template>
<script>
import SinisterHistory from './sinisterhistory.js'
export default SinisterHistory
</script>



// WEBPACK FOOTER //
// src/views/private/regulation/auto/history/SinisterHistory.vue